import { Container } from 'inversify';
import { DiContainerInjectFn } from './ts';
// @ts-ignore
//import * as injectModules0 from '../agriculture/agriculture.di.ts'; import * as injectModules1 from '../auth/auth.di.ts'; import * as injectModules2 from '../bags/bags.di.ts'; import * as injectModules3 from '../buyer-account/buyer-account.di.ts'; import * as injectModules4 from '../common/common.di.ts'; import * as injectModules5 from '../dlp/dlp.di.ts'; import * as injectModules6 from '../logistics/logistics.di.ts'; import * as injectModules7 from '../mixing/mixing.di.ts'; import * as injectModules8 from '../offer/offer.di.ts'; import * as injectModules9 from '../search/search.di.ts'; import * as injectModules10 from '../seller-account/seller-account.di.ts'; import * as injectModules11 from '../warehouses/warehouses.di.ts'; var injectModules = [injectModules0, injectModules1, injectModules2, injectModules3, injectModules4, injectModules5, injectModules6, injectModules7, injectModules8, injectModules9, injectModules10, injectModules11];
import authDi from '@@/auth/auth.di';
import offerDi from '@@/offer/offer.di';
import bagsDi from '@@/bags/bags.di';
import commonDi from '@@/common/common.di';
import mixingDi from '@@/mixing/mixing.di';
import warehousesDi from '@@/warehouses/warehouses.di';
import agricultureDi from '@@/agriculture/agriculture.di';
import sellerAccountDi from '@@/seller-account/seller-account.di';
import logisticsDi from '@@/logistics/logistics.di';
import buyerAccountDi from '@@/buyer-account/buyer-account.di';
import searchDi from '../search/search.di';
import dlpDi from '@@/dlp/dlp.di';

const injectModules = {
  authDi,
  offerDi,
  bagsDi,
  commonDi,
  mixingDi,
  warehousesDi,
  agricultureDi,
  sellerAccountDi,
  logisticsDi,
  buyerAccountDi,
  searchDi,
  dlpDi,
}

// Иногда возникает ошибка в режиме разработки - 'No matching bindings found for serviceIdentifier:'. console.log исправляет обновление сервера
// console.log(injectModules);

const DiContainer = new Container();

Object.values(injectModules).forEach((module) => {
  // @ts-ignore
  module(DiContainer);
  // module.default
});

export { DiContainer };
